export const WIDGET_CONSENT_STATE_ATTRIBUTE = 'consent-state';

export type WidgetConsentState = 'prompt' | 'granted' | 'denied';

export const DEFAULT_WIDGET_CONSENT_STATE: WidgetConsentState = 'prompt';

export function normalizeWidgetConsentState(
  value: string | null | undefined,
): WidgetConsentState {
  const normalized = value?.trim().toLowerCase();

  if (normalized === 'prompt') {
    return 'prompt';
  }

  if (normalized === 'granted') {
    return 'granted';
  }

  if (normalized === 'denied') {
    return 'denied';
  }

  return DEFAULT_WIDGET_CONSENT_STATE;
}

export function resolveWidgetConsentState(element: HTMLElement) {
  return normalizeWidgetConsentState(
    element.getAttribute(WIDGET_CONSENT_STATE_ATTRIBUTE),
  );
}

export function updateWidgetConsentStateAttribute(
  element: HTMLElement | null | undefined,
  consentState: WidgetConsentState,
): void {
  if (!element) {
    return;
  }

  if (consentState === DEFAULT_WIDGET_CONSENT_STATE) {
    element.removeAttribute(WIDGET_CONSENT_STATE_ATTRIBUTE);
    return;
  }

  if (element.getAttribute(WIDGET_CONSENT_STATE_ATTRIBUTE) === consentState) {
    return;
  }

  element.setAttribute(WIDGET_CONSENT_STATE_ATTRIBUTE, consentState);
}
